import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Suntable from './suntable'

import YeionTablePrivacyAndroid from './yeiontable/privacyandroid'
import YeionTableTerm from './yeiontable/term'
import YeionTableIndex from './yeiontable'
import YeionTablePrivacyiOS from './yeiontable/privacyios'
import YeionDownLoadPage from './yeiontable/download'

import DaigouGJPrivacyAndroid from './daigougj/privacyandroid'
import DaigouGJTerm from './daigougj/term'
import DaigouGJIndex from './daigougj'
import DaigouGJPrivacyiOS from './daigougj/privacyios'
import DaigouGJAbout from './daigougj/about'

import QnbgPrivacyAndroid from './qnbg/privacyandroid'
import QnbgTerm from './qnbg/term'
import QnbgIndex from './qnbg'
import QnbgPrivacyiOS from './qnbg/privacyios'
import BggfMember from './qnbg/member'
import QnbgDownLoadPage from './qnbg/download'

import ZizaitsPrivacyAndroid from './zizaits/privacyandroid'
import ZizaitsTerm from './zizaits/term'
import ZizaitsPrivacyiOS from './zizaits/privacyios'
import ZizaitsDownloadPage from './zizaits/download'

const AppRouter: React.FC = () => {
    return (
        <Router>
            <Routes>
                {/* 根路径 */}
                <Route path='/' element={<Suntable />} />
                {/* 野离子表单 */}
                <Route path='yeiontable' element={<YeionTableIndex />} />
                <Route path="yeiontable/privacyandroid" element={<YeionTablePrivacyAndroid />} />
                <Route path="yeiontable/term" element={<YeionTableTerm />} />
                <Route path='yeiontable/privacyios' element={<YeionTablePrivacyiOS />} />
                <Route path='yeiontable/download' element={<YeionDownLoadPage />} />

                {/* 代购管家SunTable */}
                <Route path='daigougj' element={<DaigouGJIndex />} />
                <Route path="daigougj/privacyandroid" element={<DaigouGJPrivacyAndroid />} />
                <Route path="daigougj/Term" element={<DaigouGJTerm />} />
                <Route path='daigougj/privacyios' element={<DaigouGJPrivacyiOS />} />
                <Route path='daigougj/about' element={<DaigouGJAbout />} />

                {/* 表格工坊 */}
                <Route path='qnbg' element={<QnbgIndex />} />
                <Route path="qnbg/privacyandroid" element={<QnbgPrivacyAndroid />} />
                <Route path="qnbg/term" element={<QnbgTerm />} />
                <Route path='qnbg/privacyios' element={<QnbgPrivacyiOS />} />
                <Route path='qnbg/member' element={<BggfMember />} />
                <Route path='qnbg/download' element={<QnbgDownLoadPage />} />

                {/* 自在听书 */}
                <Route path='zizaits' element={<ZizaitsDownloadPage />} />
                <Route path='zizaits/download' element={<ZizaitsDownloadPage />} />
                <Route path='zizaits/privacyandroid' element={<ZizaitsPrivacyAndroid />} />
                <Route path='zizaits/privacyios' element={<ZizaitsPrivacyiOS />} />
                <Route path='zizaits/term' element={<ZizaitsTerm />} />
            </Routes>
        </Router>
    );
}

export default AppRouter;